<i18n
  src="@/locales/views/packing_house/quality_control/process/list_processes.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>
  <div class="bg-white shadow overflow-hidden sm:rounded-md" v-if="render_list">
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="packing_house_process in packing_house_processes"
        :key="packing_house_process.id"
      >
        <div
          href="#"
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowProcess(packing_house_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ packing_house_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a
                  class="link"
                  @click.prevent="goToShowProcess(packing_house_process)"
                  ><i class="fa-solid fa-pen"></i
                  ><span class="space-icon"></span
                  >{{ $t("labels.manage_link") }}</a
                >
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex space-x-6">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-crate-apple flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{
                    packing_house_process.num_harvested_batches_with_inspects
                  }}
                  /
                  {{ packing_house_process.num_harvested_batches }}
                </p>
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-box-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ packing_house_process.num_quality_inspects }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/packing_house/requesters/quality_control/process/list_processes.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: { BreadCrumbs },
  name: "ListProcesses",
  props: ["packing_house_id"],
  data() {
    return {
      packing_house_processes: [],
      render_list: false,
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response = await Requester.fetchAgroExporterProcesses(
        this.packing_house_id
      );
      this.packing_house_processes = response.data;
      this.render_list = true;
    },
    goToShowProcess: function (packing_house_process) {
      this.$router.push({
        name: "ph_quality_control_process_list_harvested_batches_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: packing_house_process.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => this.fetchAgroExporterProcesses())
    );
  },
};
</script>
